import styled from "styled-components";

export const Buttom = styled.div`
    display: flex;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 24px;
        height: 24px
    }
`;